import React, { useState } from 'react';
import Toast from './Toast';

export default function AuditLog() {
  const [toast, setToast] = useState(null);

  const showToast = (msg) => {
    setToast({ message: msg, type: 'default' });
    setTimeout(() => setToast(null), 3000);
  };

  return (
    <div className="admin-page">
      <div className="admin-page__head">
        <div>
          <h1 className="admin-page__title">Audit log <em>· events</em></h1>
          <div className="admin-page__sub">
            <span><strong>1,284</strong> events · 30d</span>
            <span><strong>14</strong> alerts open</span>
            <span>Retention: 12 months</span>
          </div>
        </div>
        <div className="admin-page__actions">
          <button className="btn-ghost" onClick={() => showToast('Export initiated')}>Export</button>
        </div>
      </div>

      <div className="admin-toolbar">
        <div className="admin-tabs">
          {['All', 'Auth', 'Content', 'Permissions', 'Alerts'].map((tab, idx) => (
            <div key={idx} className={`admin-tab ${idx === 0 ? 'is-active' : ''}`}>{tab}</div>
          ))}
        </div>
        <div className="admin-filters">
          <select className="filter-select"><option>Range — Last 30d</option></select>
          <select className="filter-select"><option>Actor — All</option></select>
        </div>
      </div>

      <table className="projects-table" style={{ marginTop: '20px' }}>
        <thead>
          <tr>
            <th>Timestamp</th>
            <th>Actor</th>
            <th>Event</th>
            <th>Target</th>
            <th>Source</th>
          </tr>
        </thead>
        <tbody>
          {[
            { time: '2 hours ago', actor: 'KV', event: 'CONTENT.PUBLISH', target: 'Aldgate Advisor Cockpit', source: '203.45.71.2 · Sydney' },
            { time: '5 hours ago', actor: 'TR', event: 'ENQUIRY.REPLY', target: 'James Ng', source: '192.168.1.45 · Sydney' },
            { time: 'Yesterday', actor: 'AN', event: 'MEDIA.UPLOAD', target: '3 assets', source: '203.45.71.2 · Sydney' }
          ].map((row, idx) => (
            <tr key={idx}>
              <td style={{ fontFamily: 'Geist Mono', fontSize: '12px', color: 'var(--graphite-2)' }}>{row.time}</td>
              <td>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', fontSize: '13px' }}>
                  <div style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: 'var(--ivory)', color: 'var(--ink)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, fontSize: '10px', flexShrink: 0 }}>
                    {row.actor}
                  </div>
                  {row.actor}
                </div>
              </td>
              <td><code style={{ fontFamily: 'Geist Mono', fontSize: '11px', color: row.event.includes('PUBLISH') || row.event.includes('UPLOAD') ? '#6FCF97' : row.event.includes('REPLY') ? 'var(--accent)' : 'var(--graphite-2)' }}>{row.event}</code></td>
              <td style={{ fontSize: '13px' }}>{row.target}</td>
              <td style={{ fontFamily: 'Geist Mono', fontSize: '11px', color: 'var(--graphite-2)' }}>{row.source}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {toast && <Toast message={toast.message} type={toast.type} />}
    </div>
  );
}
